import IField from "@mapmycustomers/shared/types/fieldModel/IField";

import activityFieldModel, { ActivityFieldName } from "./ActivityFieldModel";

/**
 * Returns whichever of the activity person/people field is currently visible
 * (the other one is filtered out at app startup based on the
 * multiContactActivities add-on flag). Use this in place of
 * activityFieldModel.getByName(ActivityFieldName.PERSON) for code that needs
 * the live picker field for activities regardless of the add-on state.
 */
const getActivityPersonField = (): IField | undefined =>
  activityFieldModel.getByName(ActivityFieldName.PEOPLE) ??
  activityFieldModel.getByName(ActivityFieldName.PERSON);

export default getActivityPersonField;
